// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_FEED_POST = "Pridaj diskusiu";
export const COUNSELLING_IS_ARCHIVED = "Porad\u0148a je uzavret\u00e1";
export const FORUM_ADD_CONTEST = "Pridaj s\u00fa\u0165a\u017e";
export const FORUM_ADD_QUESTION = "Polo\u017e anonymn\u00fa ot\u00e1zku";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const FORUM_REPORTED_POSTS = "Nahl\u00e1sen\u00e9 pr\u00edspevky";
export const FORUM_TOPIC_DELETE = "Zma\u017e";
export const FORUM_TOPIC_EDIT = "Uprav popis a fotku";
export const FORUM_TOPIC_SEO_WITH_AI = "Skontroluj diskusie s AI";
export const SEO_DESCRIPTION_FORUM_topic = "V\u0161etko o t\u00e9me %(topic)s. Zdie\u013eaj sk\u00fasenosti, n\u00e1jdi u\u017eito\u010dn\u00e9 rady a zapoj sa do diskusi\u00ed o tom, \u010do \u0165a zauj\u00edma.";
export const SEO_TITLE_FORUM = "Diskusie";
